import { useState } from 'react';
import { uiPrompt } from '../../utils/dialogs.js';

// "Copy link" for staff (Joe, 21 Oct 2026): copies a Blake address that opens
// this thing for anyone logged in. Not a share link — someone without a
// Blake login just gets the login page.
export default function CopyLinkButton({ path, label = 'Copy link', style }) {
  const [done, setDone] = useState(false);
  async function copy() {
    const url = `${window.location.origin}${path}`;
    try {
      await navigator.clipboard.writeText(url);
      setDone(true); setTimeout(() => setDone(false), 1800);
    } catch {
      await uiPrompt('Copy this link (staff need to be logged in to Blake to open it):', url, { title: 'Link' });
    }
  }
  return (
    <button type="button" onClick={copy} title="A link that opens this in Blake for anyone logged in"
      style={{ padding: '4px 10px', borderRadius: 'var(--radius)', fontSize: 12, fontWeight: 600, cursor: 'pointer', border: '1px solid var(--border)', background: 'var(--surface-2)', color: done ? 'var(--pld-green)' : 'var(--text)', whiteSpace: 'nowrap', ...style }}>
      {done ? '✓ Link copied' : `🔗 ${label}`}
    </button>
  );
}
